import { render, staticRenderFns } from "./PLPrestadores.vue?vue&type=template&id=1127d46e&scoped=true&"
import script from "./PLPrestadores.vue?vue&type=script&lang=js&"
export * from "./PLPrestadores.vue?vue&type=script&lang=js&"
import style0 from "./PLPrestadores.vue?vue&type=style&index=0&id=1127d46e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127d46e",
  null
  
)

export default component.exports